import { routerConfig } from "./router.config";
import { HTTP_INTERCEPTORS } from '@angular/common/http';

/**
 *  Modules
 */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { MomentModule } from 'angular2-moment';
import { MomentTimezoneModule } from 'angular-moment-timezone';
import { Autosize } from 'ng-autosize';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SuiModule } from 'ng2-semantic-ui';
import { ToastyModule } from 'ng2-toasty';
import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome'

/**
 * Services
 */
import { TimezonesService } from './shared/services/timezones.service';
import { UtilitiesService } from './shared/services/utilities.service';
//import { TopicsService } from './shared/services/topics.service'; <-- This will eventually be topics service
import { AuthService } from './shared/services/auth.service';
import { CanActivateViaAuthService } from './shared/services/can-activate-via-auth.service';
import { CanActivateViaPermissionService } from './shared/services/can-activate-via-permission.service';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';

/**
 *  Components
 */
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { HeaderComponent } from './components/header/header.component';


/**
 *  Pipes
 */
import { AbsPipe } from './shared/pipes/abs.pipe';
import { SafeUrlPipe } from './shared/security/safe-url.pipe';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    Autosize,
    AbsPipe,
    HeaderComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    Angular2FontawesomeModule,
    MomentModule,
    MomentTimezoneModule,
    SuiModule,
    ToastyModule,
    RouterModule.forRoot(routerConfig),
  ],
  providers: [
    AuthService,
    TimezonesService,
    //TopicsService, <- This will eventually be the topics provider
    CanActivateViaAuthService,
    CanActivateViaPermissionService,
    UtilitiesService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: TokenInterceptor,
    //   multi: true
    // }
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts